const ssoProviderDomainConfig = {
  name: 'SSO Provider Domain',
  endpoint: '/internal_admin/admin_kit/sso_provider_domains',
  modelKey: 'sso_provider_domain',
  titleField: 'domain',

  columns: [
    { name: 'domain', title: 'Domain', type: 'link' },
    { name: 'provider_label', title: 'Provider' },
    { name: 'active', title: 'Active', type: 'boolean' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[domain_cont]', label: 'Domain' },
    {
      name: 'q[provider_eq]',
      label: 'Provider',
      options: (props) => props.providers ?? [],
    },
    {
      name: 'q[active_eq]',
      label: 'Status',
      options: (props) => props.activeOptions ?? [],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'domain', label: 'Domain' },
    { name: 'provider_label', label: 'Provider' },
    { name: 'active', label: 'Active', type: 'boolean' },
    { name: 'description', label: 'Description' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'domain',
        label: 'Domain',
        type: 'text',
        required: true,
        helpMessage: 'Valid domain name (e.g., company.com)',
      },
      {
        name: 'provider',
        label: 'Provider',
        type: 'select',
        options: (props) => props.providers ?? [],
      },
      {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        rows: 3,
        span: 2,
      },
      { name: 'active', label: 'Active', type: 'checkbox', defaultValue: true },
    ],
  },
};

export default ssoProviderDomainConfig;
